export const newLine = {
    whiteSpace: 'pre-line',
} as const;